import { render, staticRenderFns } from "./CrewCertificate.vue?vue&type=template&id=83ee4d48&scoped=true&"
import script from "./CrewCertificate.vue?vue&type=script&lang=js&"
export * from "./CrewCertificate.vue?vue&type=script&lang=js&"
import style0 from "./CrewCertificate.vue?vue&type=style&index=0&id=83ee4d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ee4d48",
  null
  
)

export default component.exports